import {
  Carousel,
  Dropdown,
  NavMenu,
  SearchDrawer,
  ViewToggle
} from '@bionews-ui/library';

import SearchFilter from './search-filter';
import CopyButton from './copy-button';

new Carousel();
new Dropdown();
new NavMenu();
new CopyButton();
new SearchDrawer();
new SearchFilter();
new ViewToggle();
